/** @format */

export const amountProductsCart = () => {
	return JSON.parse(localStorage.getItem('cart'))?.reduce((sum, item) => sum + item.quantity, 0)
}
